import BasePerimeter from "./base";

export default new BasePerimeter({
  purpose: "clients",
  govern: {
    "can view": function() {
      return this.isSuperAdmin() || this.isAdmin() || this.isClientAdmin() || this.isAgencyAdmin();
    },
    "can editMainFields": function() {
      return this.isSuperAdmin() || this.isAdmin() || this.isClientAdmin();
    },
    "can add": function() {
      return this.isSuperAdmin() || this.isAdmin();
    },
    "can viewOfficesTab": function() {
      return this.isAdmin() || this.isSuperAdmin();
    },
    "can viewIntegrationTab": function() {
      return this.isAdmin() || this.isSuperAdmin();
    },
    "can viewPaymentDetails": function() {
      return this.isClientAdmin() || this.isAdmin() || this.isSuperAdmin();
    },
    "can changePaymentOption": function() {
      return this.isAdmin() || this.isSuperAdmin();
    },
    "can changeClientCard": function() {
      return this.isClientAdmin();
    },
    "can editTradingTerms": function() {
      return this.isAdmin() || this.isSuperAdmin();
    },
    "can editDisplayConfig": function() {
      return this.isAdmin() || this.isSuperAdmin();
    }
  }
});
